import "../../../@adapters/maplibre-gl-leaflet/leaflet-maplibre-gl";
import { createElementObject, createTileLayerComponent, updateGridLayer, type LayerProps } from "@react-leaflet/core";
import L from "leaflet";
import { ResourceType, StyleSpecification, MapOptions as LibreGLMapOptions, Map as LibreGLMap } from "maplibre-gl";
import { isMapboxURL, transformMapboxUrl } from "maplibregl-mapbox-request-transformer";
import { mapboxAccessToken } from "./common";

export interface MapLibreTileLayerProps extends L.LeafletMaplibreGLOptions, LayerProps {
  style: StyleSpecification | string;
  attribution: string;
}

declare module "leaflet" {
  type LeafletMaplibreGLOptions = Omit<LibreGLMapOptions, "container">;

  class MaplibreGL extends L.Layer {
    constructor(options: LeafletMaplibreGLOptions);
    getMaplibreMap(): LibreGLMap | undefined;
    getCanvas(): HTMLCanvasElement | undefined;
    getSize(): L.Point | undefined;
    getBounds(): L.LatLngBounds | undefined;
    getContainer(): HTMLElement | undefined;
    getPaneName(): string | undefined;
  }

  function maplibreGL(options: LeafletMaplibreGLOptions): MaplibreGL;
}

export const MapLibreTileLayer = createTileLayerComponent<L.MaplibreGL, MapLibreTileLayerProps>(
  function createTileLayer({ style, attribution, ...options }, context) {
    const transformRequest = (url: string, resourceType?: ResourceType) => {
      if (isMapboxURL(url) && resourceType) {
        return transformMapboxUrl(url, resourceType, mapboxAccessToken);
      }
      return { url };
    };

    console.log("maplibre creating with attribution", attribution);

    const layer = L.maplibreGL({
      style: style,
      attributionControl: {
        customAttribution: attribution,
        compact: true,
      },
      // @ts-ignore
      noWrap: true,
      // turn off style validation to decrease the odds of random problems from provider style changes or maplibre spec changes
      validateStyle: false,
      // @ts-ignore
      transformRequest,
      ...options,
    });
    return createElementObject(layer, context);
  },
  function updateTileLayer(layer, props, prevProps) {
    // @ts-ignore this works, some kind of type problem
    updateGridLayer(layer, props, prevProps);

    const { style, attribution } = props;
    if (style && style !== prevProps.style) {
      // @ts-ignore it does exist
      layer.getMaplibreMap()?.setStyle(style);
    }

    if (attribution != null && attribution !== prevProps.attribution) {
      console.log("maplibre updating layer attribution", attribution);
      layer.options.attribution = attribution;
    }
  },
);
